import { Col, Row, Breadcrumb } from "antd";
import { useMutation, useQuery } from "react-query";
import { getRoleById, getRoles, getUsersForRole } from "../../api/roles";
import AddRoleModal from "./Modals/AddRoleModal";
import RolesList from "./RolesList";
import { useEffect, useState } from "react";
import UsersForRole from "./Modals/UsersForRole";
import AllUsersModal from "./Modals/AllUsersModal";
import { Link } from "react-router-dom";
import Title from "../UI/Title/Title";
import AddButton from "../UI/AddButton/addbutton";
import ResetButton from "../UI/ResetButton/resetbutton";
import { useTranslation } from "react-i18next";
import { Search } from "../UI/Search/Search";
import { FilterInput } from "../UI/FilterApi/filterapi";

const Roles = () => {
  const [t] = useTranslation("common");
  const [isAddEditRoleOpen, setIsAddEditRoleOpen] = useState(false);
  const [isUsersForRoleOpen, setIsUsersForRoleOpen] = useState(false);
  const [isAllUsersModalOpen, setIsAllUsersModalOpen] = useState(false);
  const [selectedRole, setSelectedRole] = useState<{} | any>();
  const [selectedRoleId, setSelectedRoleId] = useState();
  const [page, setPage] = useState<number>(1);
  const [q, setQ] = useState("");
  const [isActive, setIsActive] = useState<boolean>();
  const [users, setUsers] = useState();
  const {
    data: roles,
    refetch: refetchRoles,
    isLoading: isRolesLoading,
  } = useQuery("roles", () => getRoles(isActive, q, page), {
    onSuccess: (res) => {},
  });
  const { mutateAsync: getRoleByIdMutation } = useMutation(
    "getRole",
    (id: any) => getRoleById(id)
  );

  const resetFilters = () => {
    setTableKey((tableKey) => tableKey + 1);
    setSearchText("");
    setQ("");
    setIsActive(undefined);
  };
  const [, setSearchText] = useState("");
  const [tableKey, setTableKey] = useState(1000);

  const { mutateAsync: getAllUsersForRole, isLoading: isUsersLoading } =
    useMutation("getAllUsers", (id: any) => getUsersForRole(id));

  const handleEditRoleModal = (roleId: any) => {
    getRoleByIdMutation(roleId).then((res) => {
      setSelectedRole(res.data.data);
      setIsAddEditRoleOpen(true);
    });
  };

  const handleGetUsersForRole = (roleId: any) => {
    getAllUsersForRole(roleId).then((res) => {
      setUsers(res.data.data);
      setIsUsersForRoleOpen(true);
    });
  };
  const handleGetAllUsers = (roleId: any) => {
    setSelectedRoleId(roleId);
    getAllUsersForRole(roleId).then((res) => {
      setUsers(res.data.data);
      setIsAllUsersModalOpen(true);
    });
  };

  useEffect(() => {
    refetchRoles();
  }, [isActive]);

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col offset={1} span={22}>
          <Breadcrumb
            items={[
              {
                title: <Link to="/main">{t("home")}</Link>,
              },
              {
                title: <>{t("system")}</>,
              },
              {
                title: (
                  <span className="breadcrumbcolor"> {t("roles-list")} </span>
                ),
              },
            ]}
          />
        </Col>
        <Col offset={1} span={22}>
          <Title title={`${t("roles-list")}`} />
        </Col>

        <Col offset={1} span={4}>
          <Search
            value={q}
            onEnter={() => {
              refetchRoles();
            }}
            onChange={(e: any) => {
              setQ(e.target.value);
            }}
          />
        </Col>

        <Col span={2}>
          <FilterInput
            key={""}
            onChange={(e: boolean) => {
              setIsActive(e);
            }}
            value={isActive}
          />
        </Col>
        <Col
          offset={14}
          span={2}
          style={{ display: "flex", justifyContent: "end", gap: 10 }}
        >
          <ResetButton
            onClick={() => {
              resetFilters();
            }}
          />
          <AddButton
            onClick={() => {
              setIsAddEditRoleOpen(true);
            }}
          />
        </Col>
        <Col offset={1} span={22}>
          <RolesList
            tableKey={tableKey}
            data={roles?.data.data}
            refetchRoles={() => refetchRoles()}
            handleEditRoleModal={handleEditRoleModal}
            handleGetUsersForRole={handleGetUsersForRole}
            handleGetAllUsers={handleGetAllUsers}
            isRolesLoading={isRolesLoading}
          />
        </Col>
      </Row>
      <AddRoleModal
        isOpen={isAddEditRoleOpen}
        setIsOpen={setIsAddEditRoleOpen}
        refetchRoles={() => refetchRoles()}
        selectedRole={selectedRole}
        setSelectedRole={setSelectedRole}
      />
      <UsersForRole
        isOpen={isUsersForRoleOpen}
        setIsOpen={setIsUsersForRoleOpen}
        users={users}
        isLoading={isUsersLoading}
      />
      <AllUsersModal
        isOpen={isAllUsersModalOpen}
        setIsOpen={setIsAllUsersModalOpen}
        users={users}
        isLoading={isUsersLoading}
        role={selectedRoleId}
      />
    </>
  );
};

export default Roles;
